export const ZIPCODE_BULK_UPSERT_FIELDS: { key: string; label: string }[] = [
  { key: 'zipCode', label: 'Zip Code' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'county', label: 'County' },
  { key: 'inSeasonDate', label: 'In Season Date' },
  { key: 'inSeasonAgreement', label: 'In Season Agreement' },
  { key: 'offSeasonDate', label: 'Off Season Date' },
  { key: 'offSeasonAgreement', label: 'Off Season Agreement' },
  { key: 'rentalMode', label: 'Rental Mode' },
  { key: 'rentalProgram', label: 'Rental Program' },
  { key: 'latitude', label: 'Latitude' },
  { key: 'longitude', label: 'Longitude' }
];
